import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

function Success() {
    const [searchParams] = useSearchParams();
    const subs = searchParams.get("session_id");
    const navigate = useNavigate()

    if (searchParams.size === 0) {
        return navigate("/login")
    }
    if (!subs || subs === null) {
        return navigate("/login")
      }

        return (
            <h1>subscription successful</h1>
        )
 
}


export default Success;